import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchServices = createAction(ACTION.FETCH_SERVICES.REQUEST, (filter = {}) => ({filter}));
